import styled from 'styled-components';
import Button from './Button';

const ComparisonButton = styled(Button)`
    justify-content: center;

    &.ant-btn-tertiary:not(.selected),
    &:not(.selected) {
        color: var(--ant-primary-color);
        background-color: white;
        border-color: var(--ant-primary-color);

        &:hover {
            color: white;
            background-color: var(--ant-primary-color);
            border-color: var(--ant-primary-color);
        }
    }
`;

export default ComparisonButton;
